export { AngularMultiSelect } from './multiselect.component';
export { ClickOutsideDirective } from './clickOutside';
export { ListFilterPipe } from './list-filter';
export { Item } from './menu-item';
export { TemplateRenderer } from './menu-item';
export { VirtualScrollComponent } from './virtual-scroll';
export { AngularMultiSelectModule } from './multiselect.component';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-multiselect-dropdown/index.js
// module id = 235
// module chunks = 10